import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authHeader = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Quem vê qual aba da Auditoria (at-90, ADR 0042).
 *
 * A matriz cobre TODAS as abas, existentes e futuras (decisão do Victor, 03/09/2026): aba nova
 * nasce declarada no registry do backend e a tela de configuração passa a listá-la sozinha.
 *
 * ⚠️ Para Cotações e Orçamentos a matriz governa só a OFERTA da aba: os dados vivem nos backends
 * dos módulos satélites, cujo `@Roles` continua sendo o teto.
 *
 * ⚠️ Sem catch: "nenhuma aba liberada" e "não consegui perguntar" são estados diferentes, e o
 * segundo não pode virar uma tela sem abas que parece configuração.
 */
export interface AbaDaAuditoria {
  chave: string;
  rotulo: string;
  dominio: 'oficina' | 'satelite';
}

export interface AbaConfigurada extends AbaDaAuditoria {
  descricao: string;
  papeis: string[];
  /** `true` = ninguém configurou; os papéis exibidos são o padrão do sistema. */
  usandoPadrao: boolean;
  papeisPadrao: string[];
}

/** Abas que o usuário do token alcança — é o que a tela consome para montar as abas. */
export const obterMinhasAbasDeAuditoria = async (): Promise<AbaDaAuditoria[]> => {
  const { data } = await axios.get(`${BACKEND_URL}/auditoria-abas/minhas`, {
    headers: authHeader(),
  });
  return data;
};

export const listarAbasDeAuditoria = async (): Promise<AbaConfigurada[]> => {
  const { data } = await axios.get(`${BACKEND_URL}/auditoria-abas`, { headers: authHeader() });
  return data;
};

export const definirPapeisDaAba = async (aba: string, papeis: string[]): Promise<void> => {
  await axios.put(`${BACKEND_URL}/auditoria-abas/${aba}`, { papeis }, { headers: authHeader() });
};
